import { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export type SkeletonGroupUniDriver = ReturnType<
  typeof skeletonGroupDriverFactory
>;

export const skeletonGroupDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
  };
};
